module.exports = __webpack_public_path__ + "img/zoom_out.5288903d.svg";